import { render, staticRenderFns } from "./TaskAdminYuSouListOrder.vue?vue&type=template&id=ca531e08&"
import script from "./TaskAdminYuSouListOrder.vue?vue&type=script&lang=js&"
export * from "./TaskAdminYuSouListOrder.vue?vue&type=script&lang=js&"
import style0 from "./TaskAdminYuSouListOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports